import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface DisciplineState {
  value?: string;
}

export const initialState: DisciplineState = {
  value: undefined,
};

export const DisciplineSlice = createSlice({
  name: 'discipline',
  initialState,
  reducers: {
    setDiscipline: (state, action: PayloadAction<string | undefined>) => {
      state.value = action.payload;
    },
    clearDiscipline: (state) => {
      state.value = undefined;
    },
  },
});

type SliceState = { discipline: DisciplineState };
export const selectDiscipline = (state: SliceState) => state.discipline.value;
export const { setDiscipline, clearDiscipline } = DisciplineSlice.actions;
export default DisciplineSlice.reducer;
